import React from 'react';
import Header from '../Components/Header'
import PageLayout from '../Layouts/PageLayout';
import { useLanguage } from '../i18n/LanguageContext';

export default function CourseDetails() {
  const { content, formatNumber } = useLanguage();
  const { courses } = content;
  const t = content.ui.courses;

  return (
   <PageLayout
        header={
            <Header title={t.title}>
                <p className="text-lg text-primary mt-2 font-medium">{t.subtitle}</p>
            </Header>
        }
        firstColumn={
            <div className="mt-6">
                <div className="bg-bgMuted/50 rounded-xl p-6 shadow-sm">
                    <h3 className="font-serif font-bold text-xl text-primary mb-4">{t.coreHeading}</h3>
                    <div className="space-y-6 text-textDark">
                        {courses.core.map((course, i) => (
                            <div key={course.name} className="border-l-4 border-secondary pl-4 py-1">
                                <h4 className="font-semibold mb-1">{formatNumber(i + 1)}. {course.name}</h4>
                                <p className="text-sm text-accent">{course.schedule}</p>
                                {course.note && <p className="text-xs text-primary mt-1">{course.note}</p>}
                                <ul className="text-sm ml-4 mt-2 space-y-1">
                                    {course.levels.map((level) => <li key={level}>• {level}</li>)}
                                </ul>
                                {course.footnote && <p className="text-xs text-primary mt-2 font-medium leading-relaxed">{course.footnote}</p>}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        }
    >
        <div className="md:col-span-2 grid">
            <div className="full-h grid md:grid-cols-2 gap-8">
                <div className="flex flex-col">
                    <div className="bg-bgMuted/50 rounded-xl p-6 shadow-sm h-full">
                        <h3 className="font-serif font-bold text-xl text-primary mb-4">{t.moreHeading}</h3>
                        <div className="space-y-4 text-textDark">
                            {courses.advanced.map((course, i) => (
                                <div key={course.name} className="border-l-4 border-primary pl-4">
                                    <h4 className="font-semibold">{formatNumber(courses.core.length + i + 1)}. {course.name}</h4>
                                    <p className="text-sm text-accent">{course.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="flex flex-col">
                    <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-xl p-6 shadow-sm h-full border border-secondary/30">
                        <h3 className="font-serif font-bold text-xl text-primary mb-4">{t.freeHeading}</h3>
                        <p className="text-sm text-accent mb-4">{t.freeSubtitle}</p>
                        <div className="space-y-4 text-textDark">
                            {courses.free.map((course, i) => (
                                <div key={course.name} className="bg-white/50 rounded-lg p-3">
                                    <h4 className="font-semibold">{formatNumber(i + 1)}. {course.name}</h4>
                                    <p className="text-sm text-primary">{course.schedule}</p>
                                    {course.description && <p className="text-xs text-accent mt-1">{course.description}</p>}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="mt-8 bg-secondary/20 rounded-xl p-6 text-center">
                <h3 className="font-serif font-bold text-xl text-primary mb-2">{t.joinHeading}</h3>
                <p className="text-textDark">{t.joinText}</p>
                <p className="text-sm text-accent mt-2">{t.admissionOpen}</p>
            </div>
        </div>
    </PageLayout>
  );
};
